import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';
import { Permission, usePermission } from '@bonusly/who-am-i';

import { Route } from '../../config/router';
import { UserProfile } from '../../types/user';
import { pathWithId } from '../../utils/api';
import { BoxLink } from '../Link';
import { UserCard } from '../User';

interface Props {
	user: UserProfile;
}

export const NavMenuHeader: FC<Props> = ({ user }) => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('navigation');
	const canAccessUserProfile = usePermission(Permission.CanAccessUserProfile);

	if (!canAccessUserProfile) {
		return (
			<Box backgroundColor="transparent" listStyleType="none" p={2} mb={1} display="block" borderRadius="md">
				<UserCard user={user} />
			</Box>
		);
	}

	return (
		<BoxLink
			backgroundColor="transparent"
			cursor="pointer"
			listStyleType="none"
			p={2}
			mb={1}
			transitionDuration="normal"
			transitionProperty="common"
			display="block"
			href={recognizeURL(pathWithId(Route.UserProfile, user.id))}
			textDecor="none"
			borderRadius="md"
			_focus={{ backgroundColor: 'secondary.bgAlpha' }}
			_hover={{ backgroundColor: 'secondary.bgAlpha' }}
		>
			<UserCard
				description={
					<Text as="span" color="blue.600" fontSize="sm">
						{t('user_menu.view_profile')}
					</Text>
				}
				user={user}
			/>
		</BoxLink>
	);
};
